<template lang="pug">
  span.block.h-30.w-30.rounded-full(:style="{background: bg, border: bg && !isWhite ? '1px solid #F6F6F6' : '', boxShadow: active ? '0 0 0 1px black' : ''}", :class="{'border border-grey-300': !bg || isWhite}")
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'ColorSwatch',
  props: ['name', 'active'],
  computed: {
    ...mapState({
      colorSwatches: state => state.site && state.site.hostem_color_swatches
    }),
    key () {
      return this.name && this.name.replace('color:', '').replace('colour:', '')
    },
    bg () {
      const item = this.key && this.colorSwatches && this.colorSwatches.find(itm => itm.key === this.key)
      return item && item.swatch
    },
    isWhite () {
      return this.key === 'white'
    }
  }
}
</script>

<style>
</style>
